// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__34ud0","additionalInfo":"AgreementModal_additionalInfo__3w8jS"};